import Module from '../wasm/color-alchemy.wasm.js';
let initPromise = null;
let _wasm = null;

export function initWASM() {
    if(!initPromise) {
        initPromise = Module()
            .then(module => {
                _wasm = module;
                return module;
            });
    }
    return initPromise;
}

/**
 * 获取 wasm module 的实例
 * @returns { { ready: Promise<any> } }
 */
export function getWASM() {
    return _wasm;
};
